import {LOGICAL_OPERATOR} from 'Core/const/global';
import {get} from 'lodash';
import {getObjectKeyByValue} from 'Core/helpers/data';

/**
 * Map external logical operators to internal values
 */
export const LOGICAL_OPERATOR_MAP = {
	AND: LOGICAL_OPERATOR.AND,
	OR: LOGICAL_OPERATOR.OR,
};

/**
 * Get input data from raw data
 * @param {string} rawData - Raw data received from IO.
 * @return {LogicalOperator}
 */
export const input = rawData => get(LOGICAL_OPERATOR_MAP, rawData);

/**
 * Get output data from input data
 * @param {LogicalOperator} inputData - Input data.
 * @return {string}
 */
export const output = inputData => getObjectKeyByValue(LOGICAL_OPERATOR_MAP, inputData);